export default "__VITE_ASSET__BWCbEgdz__"